import router from '@/router'

router.afterEach ()->
  manifest = document.querySelector '[rel="manifest"]'
  document.head.append manifest